import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { User } from '../../models/api-response.model';
import { AuthenticationService } from '../../services/authentication_service';

@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent {
  private readonly authService = inject(AuthenticationService);

  readonly user: User | null = this.authService.getCurrentUser();

  get profileInitials(): string {
    if (!this.user) {
      return 'U';
    }

    const firstInitial = this.user.name?.trim().charAt(0) || '';
    const lastInitial = this.user.lastname?.trim().charAt(0) || '';
    return `${firstInitial}${lastInitial}`.toUpperCase() || 'U';
  }
}
